import React, { useEffect, useRef, useState } from "react"
import Actions from "../actions"
import constants from "../constants"
import Store from "../store"
import CircledButton from "./circled-button"
import FullVideo from "./full-video"
import { gsap } from "gsap"
import useLockBodyScroll from "./useLockBodyScroll"

const VideoWrapper = () => {
  const [video, setVideo] = useState()
  const [isVisible, setIsVisible] = useState(false)
  const button = useRef()
  const parentVideo = useRef()
  useEffect(() => {
    gsap.set(button.current, { x: 120 })
    gsap.set(parentVideo.current, { opacity: 0 })
  }, [])
  useEffect(() => {
    const onLaunch = (item) => {
      const videos = item.video.wistia
      const wistia = videos[item.lang]
      setIsVisible(true)
      gsap.to(button.current, { x: 0, duration: 0.8, ease: "expo.out" })
      gsap.to(parentVideo.current, { opacity: 1, duration: 0.8, ease: "expo.out" })
      setTimeout(() => {
        setVideo(wistia)
        setTimeout(Actions.closeMenu)
      }, 600)
    }
    const onClose = () => {
      gsap.to(button.current, { x: 100, duration: 0.4, ease: "expo.out" })
      gsap.to(parentVideo.current, { opacity: 0, duration: 0.4, delay: 0.2, ease: "expo.out" })
      setTimeout(() => {
        setIsVisible(false)
        setVideo(undefined)
        setTimeout(Actions.openMenu)
      }, 800)
    }
    Store.on(constants.LAUNCH_VIDEO, onLaunch)
    Store.on(constants.CLOSE_VIDEO, onClose)
    return () => {
      Store.off(constants.LAUNCH_VIDEO, onLaunch)
      Store.off(constants.CLOSE_VIDEO, onClose)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useLockBodyScroll(isVisible)
  return (
    <div className={`fixed top-0 left-0 z-40 w-screen h-screen ${isVisible ? `visible` : `invisible`}`}>
      <div className={`relative h-full`}>
        <div ref={button} className={`absolute z-10 right-6 top-6 md:right-8 md:top-8`}>
          <CircledButton onClick={() => setTimeout(Actions.closeVideo)} state={`close`} className={`bg-black text-white w-12 h-12 lg:w-16 lg:h-16`} />
        </div>
        <div ref={parentVideo} className={`w-full h-full relative z-0 bg-gray-200`}>
          { video &&
            <FullVideo
              className={`w-full h-full`}
              srcDesktop={`https://embed-ssl.wistia.com/deliveries/${video.desktop}.mp4`}
              srcMobile={`https://embed-ssl.wistia.com/deliveries/${video.mobile}.mp4`}
              videoClassName={`object-contain md:object-cover`}
            />
          }
        </div>
      </div>
    </div>
  )
}

export default VideoWrapper
